import { Avatar, Button, Image, message, Tooltip } from "antd";
import classNames from "classnames";

import styles from "./index.less";

import AIIcon from "@/assets/images/chat/ai.svg";
import { ReactComponent as CopyIcon } from "@/assets/images/chat/copy2.svg";

import { copyData } from "@packages/utils";
import { ChatMessageType } from "@/services/chat";

import CardMessage from "./messages/CardMessage";
import FileMessage from "./messages/File";
import VideoMessage from "./messages/VideoMessage";
import VoiceMessage from "./messages/VoiceMessage";
import Text from "./messages/Text";

type ChatItemAIProps = {
  msg: ChatMessageType;
  onDelete: () => void;
  avatar?: string;
};

const ChatItemAI = ({ msg, avatar }: ChatItemAIProps) => {
  function renderMsg() {
    switch (msg.type) {
      case "text":
        return (
          <div className={styles["chat-item-ai-content"]}>
            <Text msg={msg} />
          </div>
        );
      case "card":
        return <CardMessage msg={msg} />;
      case "image":
        return <Image src={msg.url} className={styles.img} />;
      case "file":
        return <FileMessage msg={msg} />;
      case "video":
        return <VideoMessage msg={msg} />;
      case "voice":
        return <VoiceMessage url={msg.url} />;
      default:
        return null;
    }
  }

  return (
    <div className={classNames(styles["chat-item-ai"], styles["chat-item"])}>
      <Avatar shape="square" src={avatar || AIIcon} className={styles.avatar} />

      <div className={styles["message-box"]}>
        <div className={styles["message-container"]}>
          {renderMsg()}
          {msg.type === "text" && (
            <div className={styles["action-area"]}>
              <div className={styles.action}>
                <Tooltip title="复制" placement="bottom">
                  <Button
                    type="text"
                    className="!w-[22px] !h-[22px]"
                    icon={<CopyIcon />}
                    onClick={async () => {
                      await copyData(msg.messageOutput);
                      message.success("复制成功");
                    }}
                  />
                </Tooltip>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatItemAI;
